export default __webpack_public_path__ + "static/media/bet14.1489d8cd.png";